import { createSlice } from '@reduxjs/toolkit';
import {
  clearSearchModelElementsReducer,
  getModelElementsReducer,
  setModelElementSearchReducer,
  setMultipleModelElementSearchReducer,
  setModelElementSearchByIdsReducer,
  setLoadingSearchModelElementsReducer,
} from '@/redux/modelElements/modelElements.reducers';
import { MODEL_ELEMENTS_INITIAL_STATE_MOCK } from '@/redux/modelElements/modelElements.mock';

export const modelElements = createSlice({
  name: 'modelElements',
  initialState: MODEL_ELEMENTS_INITIAL_STATE_MOCK,
  reducers: {
    setModelElementSearch: setModelElementSearchReducer,
    setMultipleModelElementSearch: setMultipleModelElementSearchReducer,
    clearSearchModelElements: clearSearchModelElementsReducer,
    setModelElementSearchByIds: setModelElementSearchByIdsReducer,
    setLoadingSearchModelElements: setLoadingSearchModelElementsReducer,
  },
  extraReducers: builder => {
    getModelElementsReducer(builder);
  },
});

export const {
  setModelElementSearch,
  setMultipleModelElementSearch,
  clearSearchModelElements,
  setModelElementSearchByIds,
  setLoadingSearchModelElements,
} = modelElements.actions;

export default modelElements.reducer;
